import React, { createContext, useState } from 'react';
export const UserDatailContext = createContext();
export const LoaderContext = createContext();
export const SourceContext = createContext();
export const SourceProvider = (props) => {
    const [lungClicked, setLungClicked] = useState(false);
    const [is1kViewEnabled, setIs1kViewEnabled] = useState(false);
    const [genderDropdown, setGenderDropdown] = useState([]);
    const [genderFilter, setGenderFilter] = useState([]);

    return (
        <SourceContext.Provider 
            value={{
                lungClicked,
                setLungClicked,
                is1kViewEnabled,
                setIs1kViewEnabled,
                genderDropdown,
                setGenderDropdown,
                genderFilter,
                setGenderFilter
            }}
        >
            {props.children}
        </SourceContext.Provider>
    );
};


export const UserDetailProvider = (props) => {
    const [userDetails, setUserDetails] = useState('')
    return (
        <UserDatailContext.Provider value={[userDetails, setUserDetails]}>
            {props.children}
        </UserDatailContext.Provider>
    )
}

export const LoaderProvider = (props) => {
    const [IsLoading, setIsLoading] = useState(false)
    return (
        <LoaderContext.Provider value={[IsLoading, setIsLoading]}>
            {props.children}
        </LoaderContext.Provider>
    )
}

